import $ from 'jquery';

const TOGGLE_FAVOURITE = 'toggle.favourite';

/** @this {HTMLButtonElement} */
function toggleActive() {
	$(this)
		.toggleClass('active')
		.trigger(TOGGLE_FAVOURITE);
}

/** @this {HTMLButtonElement} */
function enableButton() {
	this.disabled = false;
}

/** @this {HTMLButtonElement} element */
function toggleFavourites() {
	this.disabled = true;

	const { apiUrl: url, id: ID } = this.dataset;
	const ajaxOptions = {
		url,
		data: { ID },
		dataType: 'json'
	};

	$.post(ajaxOptions)
		.done(({ status }) => {
			if (status)
				toggleActive.call(this);
		})
		.always(enableButton.bind(this));
}

export {
	toggleFavourites as default,
	TOGGLE_FAVOURITE
};
